var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 54,
    viewBox: "0 0 52 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(0.116 -0.067)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 52,
    height: 54,
    rx: 5,
    transform: "translate(-0.116 0.067)",
    fill: "#55acee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "twitter",
    transform: "translate(10.503 14.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M31.435,51.024a13.436,13.436,0,0,1-3.713,1.018,6.408,6.408,0,0,0,2.835-3.562,12.879,12.879,0,0,1-4.087,1.56,6.444,6.444,0,0,0-11.148,4.407,6.636,6.636,0,0,0,.149,1.47A18.241,18.241,0,0,1,2.189,49.175a6.446,6.446,0,0,0,1.98,8.613,6.365,6.365,0,0,1-2.912-.794v.071A6.474,6.474,0,0,0,6.421,63.4a6.432,6.432,0,0,1-1.69.212,5.7,5.7,0,0,1-1.22-.11,6.506,6.506,0,0,0,6.022,4.489,12.949,12.949,0,0,1-7.99,2.749A12.071,12.071,0,0,1,0,70.649a18.143,18.143,0,0,0,9.886,2.892c11.859,0,18.343-9.824,18.343-18.339,0-.285-.01-.56-.024-.833A12.856,12.856,0,0,0,31.435,51.024Z",
    transform: "translate(0 -48)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/TwitterIcon.e3f4caab87ed6b27562c8041c93849fe.svg";
export { ForwardRef as ReactComponent };